import { render } from "./LostOrder.vue?vue&type=template&id=523a74d6"
import script from "./LostOrder.vue?vue&type=script&lang=js"
export * from "./LostOrder.vue?vue&type=script&lang=js"

import "./LostOrder.vue?vue&type=style&index=0&id=523a74d6&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__